import { useContext } from "react";
import AuthContextTank from "../context/AuthProviderTank";

const useAuthTank = () => {

    return useContext(AuthContextTank)
}

export default useAuthTank